module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02-jp.d4af8f0bbaad3355c015930599d69452.png";